import BuyerMaturityByAge from './buyerMaturityByAge'

export default BuyerMaturityByAge
